import React from 'react';
import PropTypes from 'prop-types';

/**
 * disable이 false이면 단순 텍스트를 true이면 Input을 반환한다.
 * @param {{disable: boolean, className: any, placeholder: string, type:React.HTMLInputTypeAttribute, value: string | number, onChange: React.ChangeEventHandler, style: React.CSSProperties}} props
 * @returns
 */
const CondInputComponent = (props) => {
  const {
    disable, className, placeholder, type, value, onChange, style
  } = props;
  if (disable) {
    return <>{value === -1 ? '무제한' : value}</>;
  }
  return (
    <>
      <input
        className={className}
        placeholder={placeholder}
        type={type}
        value={value}
        onChange={onChange}
        style={style}
      />
    </>
  );
};

CondInputComponent.propTypes = {
  disable: PropTypes.bool.isRequired,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  // value: PropTypes.number || PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  style: PropTypes.object,
};

export default CondInputComponent;
